import { atom } from "recoil";

const analyticsDefault = {
		loaded: false,
		data: [],
		totalClick: 0,
		totalView: 0,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOption: {
			status: false,
		},
		currentSearch: "",
		sorting: {
			products: [],
			date: {
				type: "absolute",
				startDate: false,
				endDate: false,
			},
			sortingColumn: {
				order: "",
				column: "",
			},
			isDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
};

const analyticsInfoDefault = {
	loaded: false,
	show: false,
	data: [],
	positionSeries: [],
	totalClick: 0,
	totalView: 0,
	totalCtr: 0,
	xDomain: [new Date(), new Date()],
	error: {
		text: "",
		code: 0,
		timestamp: 0,
	},
};

export const analyticsBannersStore = atom({
	key: "analyticsBannersStore",
	default: analyticsDefault,
});

export const analyticsBannerInfoModalStore = atom({
	key: "analyticsBannerInfoModalStore",
	default: analyticsInfoDefault,
});

export const analyticsMenuBannersStore = atom({
	key: "analyticsMenuBannersStore",
	default: analyticsDefault,
});

export const analyticsMenuBannerInfoModalStore = atom({
	key: "analyticsMenuBannerInfoModalStore",
	default: analyticsInfoDefault,
});
